'use client'

import Link from 'next/link'
import { useLocale } from 'next-intl'
import { SvgOutlinedChevronRight } from '@/icons/svg-outlined-chevron-right'
import { Locale } from '@/setup/locales'
import { getLinkHref, ILinkParams } from '@/setup/routing'
import { cn } from '@/utils/styles/cn'
import { COLORS } from '@/utils/styles/colors'

interface IBreadcrumbSegment {
    label: string
    linkParams: ILinkParams
}

interface IBreadcrumbsProps {
    segments: IBreadcrumbSegment[]
    className?: string
}

export const Breadcrumbs = ({ segments, className }: IBreadcrumbsProps) => {
    const locale = useLocale()

    return (
        <nav
            aria-label="Breadcrumb"
            className={cn('flex items-center flex-wrap text-p-sm', className)}
        >
            {segments.map((segment) => {
                return (
                    <div
                        key={segment.linkParams.pattern + 'breadcrumbs'}
                        className="flex items-center"
                    >
                        <Link
                            href={getLinkHref(segment.linkParams, locale as Locale)}
                            className="text-fg-tertiary hover:text-fg-primary transition-colors"
                        >
                            {segment.label}
                        </Link>

                        {/* Ancestors-only trail: the trailing chevron points at the
                            headline below, which is the current page */}
                        <SvgOutlinedChevronRight
                            color={COLORS.fg.tertiary}
                            size={14}
                            className="mx-1 shrink-0"
                        />
                    </div>
                )
            })}
        </nav>
    )
}
